import React from 'react';
import { Box, FormControl, FormLabel, Input, Button, Typography } from '@mui/joy';
import VendorSelect from './VendorSelect';
import { today } from './MaterialForm';
import ExpiryDateShortcuts from './ExpiryDateShortcuts';
import { inputSx, submitButtonSx } from './formCommon';

export const emptyEquipmentForm = () => ({
  equipment_name: '',
  purchase_date: today(),
  purchase_cost: '',
  warranty_until: '',
  serial_no: '',
  brand_make: '',
  vendor_id: '',
  location: '',
  notes: ''
});

export const validateEquipmentForm = (form) => {
  if (!form.equipment_name?.trim() || !form.purchase_date) {
    return 'Equipment name and purchase date are required';
  }
  if (form.vendor_id === '__add_new__') {
    return 'Please select a vendor or add one first';
  }
  return null;
};

export const equipmentFormToPayload = (form) => ({
  equipment_name: form.equipment_name.trim(),
  purchase_date: form.purchase_date,
  purchase_cost: form.purchase_cost !== '' ? form.purchase_cost : null,
  warranty_until: form.warranty_until || null,
  serial_no: form.serial_no || null,
  brand_make: form.brand_make || null,
  vendor_id: form.vendor_id ? parseInt(form.vendor_id, 10) : null,
  location: form.location || null,
  notes: form.notes || null
});

const EquipmentForm = ({
  form,
  onChange,
  onSubmit,
  loading = false,
  vendors = [],
  vendorsLoading = false,
  onAddVendor,
  submitLabel = 'Add Equipment',
  fullWidthSubmit = true
}) => (
  <form onSubmit={onSubmit}>
    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Equipment Name</FormLabel>
      <Input
        name="equipment_name"
        value={form.equipment_name}
        onChange={onChange}
        required
        placeholder="Enter equipment name"
        sx={inputSx}
      />
    </FormControl>

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Purchase Cost</FormLabel>
      <Input
        type="number"
        name="purchase_cost"
        value={form.purchase_cost}
        onChange={onChange}
        min="0"
        step="0.01"
        startDecorator={<Typography sx={{ color: 'text.tertiary', fontWeight: 500 }}>₹</Typography>}
        sx={inputSx}
      />
    </FormControl>

    <FormControl sx={{ mb: 1 }}>
      <FormLabel>Purchase Date</FormLabel>
      <Input type="date" name="purchase_date" value={form.purchase_date} onChange={onChange} required sx={inputSx} />
    </FormControl>

    <ExpiryDateShortcuts
      baseDate={form.purchase_date}
      onExpiryChange={(warrantyUntil) => onChange({ target: { name: 'warranty_until', value: warrantyUntil } })}
      hintLabel="Set warranty from purchase date"
    />

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Warranty Until</FormLabel>
      <Input type="date" name="warranty_until" value={form.warranty_until} onChange={onChange} sx={inputSx} />
    </FormControl>

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Serial No</FormLabel>
      <Input name="serial_no" value={form.serial_no} onChange={onChange} sx={inputSx} />
    </FormControl>

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Brand / Make</FormLabel>
      <Input name="brand_make" value={form.brand_make} onChange={onChange} sx={inputSx} />
    </FormControl>

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Location</FormLabel>
      <Input name="location" value={form.location} onChange={onChange} sx={inputSx} />
    </FormControl>

    <FormControl sx={{ mb: 2 }}>
      <FormLabel>Notes</FormLabel>
      <Input name="notes" value={form.notes} onChange={onChange} sx={inputSx} />
    </FormControl>

    <VendorSelect
      vendors={vendors}
      value={form.vendor_id || ''}
      onChange={(vendorId) => onChange({ target: { name: 'vendor_id', value: vendorId } })}
      onAddNew={onAddVendor}
      loading={vendorsLoading}
      required={false}
      allowEmpty
    />

    <Box sx={{ display: 'flex', justifyContent: fullWidthSubmit ? 'stretch' : 'flex-end', mt: 1 }}>
      <Button type="submit" loading={loading} fullWidth={fullWidthSubmit} sx={submitButtonSx}>
        {submitLabel}
      </Button>
    </Box>
  </form>
);

export default EquipmentForm;
